// Curated illustrated avatars (memoji-style) sourced from a Figma community pack.
// Each entry is served from this app at /avatars/illustrated/<filename>.
const illustrated = Array.from({ length: 56 }, (_, i) => ({
  file: `memoji-${String(i + 1).padStart(2, "0")}.png`,
}));

export default illustrated;
